export default {
  baseUrl: "https://shareupdigitalspace.fra1.digitaloceanspaces.com",
};
